export default __webpack_public_path__ + "v1.18.25/static/media/chevron-right.f060fc1b.svg";